<template>
  <div>
    <v-layout wrap justify-center align-center mb-5 class="contenidoCurso" v-if="respuestas.length != 0">
      <v-flex xs11 sm9 md9 :class="`animated dura-2 zoomIn`">
        <table class="egt">
          <tr v-for="(el, idx) in elementos" :key="idx" 
              :class="[
                {
                  'seleccionado':seleccionado[idx]
                },
                `animated dura-${idx+3} zoomIn`
              ]"
            >
            <td class="checkbox-list">
              <input type="checkbox" 
                    :id="el.letra" 
                    :value="el.letra"
                    v-model="checkbox"
                    @click="seleccionado[idx]=!seleccionado[idx]"
              >
            </td>
            <td class="tabla-letra">
              <span v-html="el.letra"></span>
            </td>
            <label  :for="el.letra">
              <td>
                <span v-html="el.pregunta"></span>
              </td>
            </label>
          </tr>
        </table>
      </v-flex>      
    </v-layout>
    <v-layout row wrap justify-center align-center class="contenidoCurso" :class="`animated dura-1
     zoomIn`">
      <v-flex xs5 sm4 md3 v-if="btnComprobar">
        <div class="contenedot-btn" :class="{'noclick': checkbox.length==0}">
          <button class="btn-actividad hvr hvr-scale"
                  v-if="!$vuetify.breakpoint.xs" 
                  @click="evaluar()"
            >
            Comprobar
          </button>
          <button class="btn-actividad hvr hvr-scale" 
                  @click="activarModal()"
                  v-if="$vuetify.breakpoint.xs"
            >
            Comprobar
          </button>
        </div>
      </v-flex>
      <v-flex xs5 sm4 md3 v-if="this.contadorIntentos > 3">
        <div class="contenedot-btn" >
          <button class="btn-actividad btn-respuestas hvr hvr-scale"
                  @click="verRespuestas()"
                  :class="{'noclick':!btnComprobar}"
            >
            Ver respuestas
          </button>
        </div>
      </v-flex> 
    </v-layout>
    <!--
        <v-layout row wrap justify-center align-center  
                class="contenidoCurso" 
                v-if="retroalimentacion &&  !$vuetify.breakpoint.xs"
        >
        <v-flex xs12 sm9 md8 v-if="positiva" class="retro-group" >
            <v-layout wrap row justify-center align-center>
            <v-flex xs12 sm1 md1 class="retro-img">
                <img v-if="positiva" :src="require('../assets/imagenes_compartidas/retro-bien.png')" alt="">
            </v-flex>
            <v-flex xs11 sm6 md6 class="retro-txt">
                <p>
                ¡<span class="instruccion">Muy bien</span> has respondido correctamente!
                </p>
            </v-flex>
            </v-layout>
        </v-flex> 
        <v-flex xs12 sm9 md8 v-if="!positiva" class="retro-group">
            <v-layout wrap row justify-center align-center>
            <v-flex xs12 sm1 md1  class="retro-img">
                <img v-if="!positiva" :src="require('../assets/imagenes_compartidas/retro-mal.png')" alt="">
            </v-flex>
            <v-flex xs11 sm10 md10 class="retro-txt">
                <p>
                <span class="instruccion">No es la respuesta correcta</span>, pero no te preocupes, este curso te permitirá profundizar en este y 
                otros temas relacionados con crisis y continuidad.
                </p>
            </v-flex>
            </v-layout>  
        </v-flex> 
        </v-layout>
    -->
    <!-- MODAL -->
    <modal-app v-model="retroalimentacion" :width="'500px'">
        <template slot="modaltittle"></template>
        <template slot="modalcontent">
            <v-layout row wrap justify-center align-center>
                <v-flex xs12 v-if="positiva" class="retro-group" >
                    <v-layout wrap row justify-center align-center>
                        <v-flex xs12 sm1 md1 class="retro-img">
                            <img v-if="positiva" :src="require('../assets/imagenes_compartidas/retro-bien.png')" alt="">
                        </v-flex>
                        <v-flex xs11 sm10 md9 class="retro-txt">
                            <p>
                            ¡<span class="instruccion">Muy bien</span> has respondido correctamente!
                            </p>
                        </v-flex>
                    </v-layout>
                </v-flex> 
                <v-flex xs12 v-if="!positiva" class="retro-group">
                    <v-layout wrap row justify-center align-center>
                        <v-flex xs12 sm1 md1  class="retro-img">
                            <img v-if="!positiva" :src="require('../assets/imagenes_compartidas/retro-mal.png')" alt="">
                        </v-flex>
                        <v-flex xs11 sm10 md10 class="retro-txt">
                            <p>
                            <span class="instruccion">No es la respuesta correcta</span>, pero no te preocupes, este curso te permitirá profundizar en este y 
                            otros temas relacionados con crisis y continuidad.
                            </p>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </template>
    </modal-app>
  </div>
</template>
<script>
import nextConditions from "../js/mixins/nextConditions";
export default {
    props:{
        elementos:{
            type:Array,
            default:[
                {
                    letra:"A",
                    pregunta:`Prueba`,
                    respuesta:true
                }
            ]
        },
        respuestas:{
            type:Array,
            default:['A']
        },

    },
  mixins: [nextConditions],
  data() {
    return {
      checkbox:[],
      seleccionado:[],
      retroalimentacion:false,
      positiva:false,
      mostrarReflexion:false, 
      //modal
      modal:false,
      mensaje:{},
      width:'400px',
      vistos:Array(4).fill(false),
      contadorIntentos:0,
      btnComprobar:true
    }
  },
  methods:{
    reiniciar(){
      if (!this.positiva) {
        this.seleccionado=Array(4).fill(false)
        this.checkbox=[]
      }      
    }, 
    evaluar(){
      this.contadorIntentos +=1
      this.retroalimentacion = true
      let check=this.checkbox.sort()
      let resp=this.respuestas.sort()
      let resultado = resp.every((el,idx) =>{
        if (el == check[idx]) { return el }
      })


      if (resultado) {
        this.positiva = true
        this.$emit('activar')
        setTimeout(() => {
          this.$store.commit('nextShow', true)
        }, 2000);
      }else{ this.positiva = false }
    },
    activarModal(){
      this.modal = true
      this.evaluar()
    },
    verRespuestas(){
      this.seleccionado=Array(3).fill(false)
      this.checkbox=[]
      this.btnComprobar=false
      this.checkbox= this.respuestas.sort()
      this.evaluar()
      this.elementos.map((el, idx) => {
          if (el.respuesta) {this.$set(this.seleccionado,idx,true)}
      })
      this.$emit('activar')
    }
  },
  created(){
    this.$store.commit('scrollShow', false)
    //this.$store.commit('nextShow', true)
  },
  watch: {
    currentText(val) {
      if (val >= this.dialogos.length - 1){
          this.$store.commit('nextShow', true)
      }

    }
  }
}
</script>
<style lang="scss" scoped>

@import '../sass/globals';

.contenidoCurso{
  //height: 100vh;
  //margin-top: 50px;
}
h1{
  font-family: FontBase-Bold;
  font-size: 1.9rem;
}
h2{
  line-height: 1.7rem;
  color: $color-primary;
}
p{
  font-size: 1.2rem;
  font-family: FontBase-Regular;
}
table, td, th{
  border: 1px solid #eaeaea00;
}
.tabla-letra{
  color: $color-secondary;
  font-family: FontBase-Bold;
}
tr:hover{
  background: #eaeaea;
}
.btn-actividad{
  margin-top: 20px;
  font-family: FontBase-Regular;
  color: $color-primary;
  font-size:1.5rem;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 3px solid $color-complement-two;
  border-radius: 10px;
  line-height: 1.7rem;
  height: 60px;
}
@media (max-width: 600px) {
    .btn-actividad{
      margin-top: 0px;
      height: 60px;
      padding-left: 10px;
      padding-right: 10px;
      font-size:1.1rem;
    }
}
.btn-actividad:hover{  
    color: $color-complement-one;
    border: 3px solid $color-complement-one;
}
.btn-respuestas{
  margin-left: 0px;
}
.contenedot-btn{
  display: flex;
  justify-content: center;
}
.seleccionado, .seleccionado:hover{
  background: $color-complement-one;
}
input[type=checkbox]{
  opacity: 0;
}
tr, label{
  cursor: pointer;
  height: auto;
  width: 100%;
}
.checkbox-list{
  display: none;
}
.retro-img{
  display: flex;
  align-items: center;
  justify-content: end;
  img{
    height: 40px;
    width: 40px;
  }
}
@media (max-width: 600px) {
  .retro-img{
    justify-content: center;
  }
  .retro-txt p{
    text-align: center;
  }
}
.retro-txt{
  display: flex;
  align-items: center;
  justify-content: start;
  text-align: start;
  p{
    margin-bottom: 0;
  }
}
.img-modal-title{
  opacity: 0.2;
}
@media (min-width: 600px) {
  .retro-group{
    display: flex;
    align-items: center;
    .retro-img{
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
}
@media (max-width: 600px) {
  .retro-group{
    .retro-img{
      margin-bottom: 20px;
    }
  }
}

.contenedor-img{
  display: flex;
  justify-content: center;
  img{
    width: 100px;
    height: auto;
  }
}
</style>
